"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocomotiveScroll = void 0;
const react_1 = require("react");
const LocomotiveScroll_context_1 = require("./LocomotiveScroll.context");
function useLocomotiveScroll() {
    return react_1.useContext(LocomotiveScroll_context_1.LocomotiveScrollContext);
}
exports.useLocomotiveScroll = useLocomotiveScroll;
useLocomotiveScroll.displayName = 'useLocomotiveScroll';
